var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagAngola(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_14860)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 16C0 7.1635 7.1635 0 16 0C24.8365 0 32 7.1635 32 16C31.3044 16 16 18.0869 16 18.0869L0 16Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 16C32 24.8365 24.8365 32 16 32C7.1635 32 0 24.8365 0 16",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8064 12.7257L15.1628 13.7101L14.6459 15.3043L16.0013 14.3183L17.3578 15.3027L16.8389 13.7089L18.1942 12.7231L16.5183 12.7241L15.9993 11.1304L15.4824 12.7246L13.8064 12.7257Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 9.07182C18.7392 8.34389 17.3606 8.00032 16 8.0027V10.0892C17.0057 10.0874 18.0246 10.3411 18.9565 10.8793C21.7801 12.5095 22.7511 16.133 21.1208 18.9566C19.4906 21.7803 15.8671 22.7512 13.0434 21.1209C12.2208 20.646 11.5568 20.0011 11.0673 19.2569L9.325 20.4072C9.98731 21.414 10.8871 22.2857 12 22.9282C15.8203 25.1338 20.7226 23.8203 22.9281 20C25.1338 16.1798 23.8203 11.2774 20 9.07182Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3869 14.6086C10.8337 15.6198 11.2051 16.888 12.2162 17.4411L18.9943 21.1449C18.5334 21.9875 18.7782 23.013 19.6207 23.474L21.4517 24.4755C22.2942 24.9365 23.3512 24.627 23.8121 23.7844L24.8137 21.9535L11.3869 14.6086Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_14860"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagAngola);
export default __webpack_public_path__ + "static/media/flag_angola.55e91b0d61dbadc7be972c95c9d0d24b.svg";
export { ForwardRef as ReactComponent };